export default __webpack_public_path__ + "static/media/kurumsalpp.e41d63e4.png";